import { Avatar, Card, Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import OrderListTable from '../LazadaOrderList/components/OrderListTable'
import PageUrls from '../../../../../../constants/page-urls'
import { useUser } from '../../../../../../hooks/useUser'
import { EOrderStatus, IOrder, OrderSummary } from '../../../../../../types/order'
import { PaginationResponseInterface } from '../../../../../../types/pagination'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { UserRole } from '../../../../../../types/user'
import LazadaOrderFilter, { IFilterMapped } from './components/LazadaOrderFilter'
import { orderMock } from '../../../../../../resources/order'
import { OrderMenuSelect } from '../LazadaOrderList/components/OrderMenuSelect'
import { Logout, PersonAdd, Settings } from '@mui/icons-material'

const LazadaOrderList = () => {
  const navigate = useNavigate()
  const { merchant, user } = useUser()
  const queryStr = queryString.parse(window.location.search)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [selectedOrders, setSelectedOrders] = useState<IOrder[]>([])
  // const hasTrackingCodeOrder = selectedOrders.filter(order => order.trackingCode)

  const onFilterChange = useCallback((newFilter: IFilterMapped) => {
    setFilter(newFilter)
  }, [setFilter])

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Marketplace.Shope.Lazada.Order}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(searchFilter)
  }, [])

  const [ordersList, setOrdersList] = useState<PaginationResponseInterface<IOrder> & { total?: OrderSummary } | any>({ data: orderMock })

  return (
    <ContentWrapper>
      <Helmet title="คำสั่งซื้อจาก Lazada" />
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item>
          <HeaderContent
            goBack
            title="คำสั่งซื้อจาก Lazada"
            routes={[]}
            descriptions="คำสั่งซื้อจาก Lazada"
            tags={
              [UserRole.ADMIN, UserRole.MERCHANT].some(role => (user.roles as UserRole[])?.includes(role)) ||
                merchant.config?.display?.totalOrder ?
                [
                  {
                    title: 'จำนวน',
                    color: 'info',
                    value: 1000,
                    classifier: 'ออเดอร์',
                  },
                  {
                    title: 'COD ทั้งหมด',
                    color: 'warning',
                    value: 100000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'โอนทั้งหมด',
                    color: 'primary',
                    value: 100000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'ยอดรวม',
                    color: 'warning',
                    value: 200000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'จำนวน',
                    color: 'info',
                    value: 100000,
                    classifier: 'ชิ้น',
                  },
                  {
                    title: 'CODส่งสำเร็จ',
                    color: 'primary',
                    value: 50000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'COD ระหว่างขนส่ง',
                    color: 'warning',
                    value: 40000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'COD ตีกลับ',
                    color: 'error',
                    value: 10000,
                    classifier: 'บาท',
                  },
                  {
                    title: 'ค้างส่ง',
                    color: 'info',
                    value: 100000,
                    classifier: 'บาท',
                  },
                ] : undefined
            }
            childrenRight={
              <>
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                >
                  <Avatar sx={{ width: 48, height: 48 }}>M</Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      width: 180,
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem onClick={handleClose}>
                    <Avatar />
                    <Typography variant="body2">HelloWorld</Typography>
                    <Logout
                      sx={{ ml: 1 }}
                    />
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Avatar />
                    <Typography variant="body2">MyJames</Typography>
                    <Logout
                      sx={{ ml: 1 }}
                    />
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                      <PersonAdd fontSize="small" />
                    </ListItemIcon>
                    เพิ่มบัญชี
                  </MenuItem>
                </Menu>
              </>
            }
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}>
        <LazadaOrderFilter
          filter={filter as any}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        {selectedOrders.length > 0 && <OrderMenuSelect
          isPrint={true}
          isReturn={true}
          onClick={(value: EOrderStatus) => {
            console.log('value', value)
          }}
          total={selectedOrders.length}
        />}
        <OrderListTable
          isLoading={ordersList.isLoading}
          data={ordersList.data?.records ?? []}
          selectedData={selectedOrders}
          setSelectedData={setSelectedOrders}
          filter={filter}
          onFilterChange={handleSearch}
          total={ordersList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>)
}

export default LazadaOrderList
